import React from "react";
import { 
  AboutSection,
  AboutContent,
  LeftAboutPanel,
  RightAboutPanel,
  MainHeader,
  Title,
  CardWrapper,
  IconCircle,
  CardTextContent,
  CardTitle,
  CardDescription,
  ImageContainer,
  StyledAboutImage,
  VideoCard,
  VideoCardText,
  VideoTime,
  VideoTitle,
  VideoPlayButton,
  PlayIcon,
  Signature
} from "./About.styles";
import SignatureImage from "../../assets/sign.png";
import Vision from "../../assets/vision.png";
import Mission from "../../assets/mission.png";
import Values from "../../assets/valeur.png";

const About = () => {
  return (
    <AboutSection>
      <AboutContent>
        <LeftAboutPanel>
          <MainHeader>A</MainHeader>
          <Title>Propos</Title>

          <CardWrapper>
            <IconCircle>
              <img 
                src={Vision} 
                alt="Notre vision"
              />
            </IconCircle>
            <CardTextContent>
              <CardTitle>Notre vision</CardTitle>
              <CardDescription>
                Lorem as many design tasks as you need without worrying about individual ipsumus fees.
              </CardDescription>
            </CardTextContent>
          </CardWrapper>

          <CardWrapper>
            <IconCircle>
              <img 
                src={Mission} 
                alt="Notre mission"
              />
            </IconCircle>
            <CardTextContent>
              <CardTitle>Notre mission</CardTitle>
              <CardDescription>
                Lorem designers get to work to deliver your request. Receive your design within a few days.
              </CardDescription>
            </CardTextContent>
          </CardWrapper>

          <CardWrapper>
            <IconCircle>
              <img 
                src={Values} 
                alt="Nos valeurs"
              />
            </IconCircle>
            <CardTextContent>
              <CardTitle>Nos valeurs</CardTitle>
              <CardDescription>
                Lorem designs, prompt replies and as many revisions as you need.
              </CardDescription>
            </CardTextContent>
          </CardWrapper>
        </LeftAboutPanel>

        <RightAboutPanel>
          <ImageContainer>
            <StyledAboutImage />
            
            <VideoCard>
              <VideoCardText>
                <VideoTime>7Min dans la Journée</VideoTime>
                <VideoTitle>d'OlaSoft</VideoTitle>
              </VideoCardText>
              
              <VideoPlayButton>
                <PlayIcon>&#9654;</PlayIcon>
              </VideoPlayButton>
            </VideoCard>

            <Signature>
              <img 
                src={SignatureImage} 
                alt="Signature"
              />
            </Signature>
          </ImageContainer>
        </RightAboutPanel>
      </AboutContent>
    </AboutSection>
  );
};

export default About;